import BaseInformation, { PreviewInformationProps } from './BaseInformation'

// Default template that uses BaseInformation
const DefaultTemplate = {
    Information: BaseInformation,
}

// All templates mapping - sử dụng BaseInformation cho tất cả
// Sau này có thể customize từng template riêng nếu cần
const PreviewTemplates: Record<
    string,
    { Information: React.FC<PreviewInformationProps> }
> = {
    // SwiftFederation
    'SwiftFederation.CDN': DefaultTemplate,
    'SwiftFederation.Transcoding': DefaultTemplate,
    'SwiftFederation.Transmuxing': DefaultTemplate,
    'SwiftFederation.Recording': DefaultTemplate,
    'SwiftFederation.StorageLFD': DefaultTemplate,
    'SwiftFederation.StorageOSS': DefaultTemplate,

    // Mlytics
    'Mlytics.Vnis': DefaultTemplate,

    // Email
    'Email.Server': DefaultTemplate,
    'Email.EGPlatform': DefaultTemplate,

    // Cloud
    'Cloud.VPS': DefaultTemplate,
    'Cloud.Hosting': DefaultTemplate,
    'Cloud.VCloud': DefaultTemplate,

    // Server
    'Server.VBM': DefaultTemplate,
    'Server.Dedicated': DefaultTemplate,
    'Server.Colocation': DefaultTemplate,

    // Domain
    'Domain.VNNIC': DefaultTemplate,
    'Domain.TLDs': DefaultTemplate,

    // SSL
    'SSL.SSL': DefaultTemplate,

    // Device Liquidation
    'Device.Liquidation': DefaultTemplate,

    // Blank/Default
    Blank: DefaultTemplate,
}

export default PreviewTemplates
